import { useQuery } from '@tanstack/react-query';
import { getUser } from 'api/user';
import { usersKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useUserQuery = (userId: string | null) => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: usersKeys.detail(companyId, userId ?? ''),
    queryFn: () => getUser(userId!).then((res) => res.data),
    enabled: !!companyId && !!userId
  });
};
